export default {
      id: "lifts-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#lifts-usage",
      toString: function () {
        return this.url;
      }
    }